const INTL_LOCALE: Record<string, string> = {
  pt: "pt-BR",
  en: "en-US",
};

function toIntlLocale(locale: string): string {
  return INTL_LOCALE[locale] ?? locale;
}

export function formatDate(date: Date | string | number, locale: string, options?: Intl.DateTimeFormatOptions): string {
  const value = date instanceof Date ? date : new Date(date);
  return new Intl.DateTimeFormat(toIntlLocale(locale), options ?? { day: "2-digit", month: "long", year: "numeric" }).format(value);
}

export function formatDateTime(date: Date | string | number, locale: string): string {
  return formatDate(date, locale, { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

// Cobranca sempre em BRL (gateway ASAAS so opera em real) independente do
// idioma de exibicao — so a convencao de milhar/decimal muda com o locale.
export function formatMoney(value: number, locale: string): string {
  return new Intl.NumberFormat(toIntlLocale(locale), { style: "currency", currency: "BRL" }).format(value);
}
